import { render, staticRenderFns } from "./MessageBubble.vue?vue&type=template&id=9210db2e&scoped=true"
import script from "./MessageBubble.vue?vue&type=script&lang=js"
export * from "./MessageBubble.vue?vue&type=script&lang=js"
import style0 from "./MessageBubble.vue?vue&type=style&index=0&id=9210db2e&prod&lang=css"
import style1 from "./MessageBubble.vue?vue&type=style&index=1&id=9210db2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9210db2e",
  null
  
)

export default component.exports